import React, { useState, useEffect } from 'react';
import type { CountdownTimerProps } from '../../types';

const CountdownTimer: React.FC<CountdownTimerProps> = ({ 
  timeLimit, 
  onTimeUp,
  startTime
}) => {
  const [timeLeft, setTimeLeft] = useState(timeLimit);
  const [isWarning, setIsWarning] = useState(false);
  
  useEffect(() => {
    if (!startTime) {
      setTimeLeft(timeLimit);
      setIsWarning(false);
      return;
    }

    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = Math.max(0, timeLimit - elapsed);
      
      setTimeLeft(remaining);
      setIsWarning(remaining <= 5 && remaining > 0);
      
      if (remaining <= 0) {
        onTimeUp();
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 100);
    
    return () => clearInterval(interval);
  }, [timeLimit, startTime, onTimeUp]);
  
  return (
    <div className={`text-2xl font-bold font-heading ${isWarning ? 'text-destructive animate-pulse' : ''}`}>
      {timeLeft}
    </div>
  );
};

export default CountdownTimer;